import { Switch, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Container from "@mui/material/Container";

import useHeight from "../../utility/hooks/useHeight";

import styles from "../../styles/layout/panel.module.scss";

// Import components
import Header from "./header";
import Footer from "./footer";
import NavBox from "./navBox";
import BottomNav from "./bottomNav";
import { Box } from "@mui/material";

const PanelLayoutNoPadding = ({ children, allRoutes = [], defaultItems }) => {
  const showHeaderFooter = useSelector(
    (state) => state.layout.showHeaderFooter,
  );
  const { search } = useLocation();
  let query = new URLSearchParams(search);
  var showFromApp = query.get("from") === "app";
  const height = useHeight();

  let from = localStorage.getItem("from");
  if (from && from === "app") {
    showFromApp = true;
  } else if (query.get("from") === "app") {
    localStorage.setItem("from", "app");
  }

  return (
    <>
      {showHeaderFooter && <Header styles={styles.header} />}

      <Container
        maxWidth="xl"
        sx={{
          pt: 0,
          pb: { xs: "70px", md: 0 },
          px: { md: 2, xs: 0 },
        }}
        className={`${styles.container} scrollable_content`}
      >
        <Switch>
          {allRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              render={() => (
                <>
                  <Box
                    sx={{
                      height: {
                        md: "calc(100dvh - 170px)",
                        xs: "calc(100dvh - 134px)",
                      },
                    }}
                  >
                    {children}
                  </Box>

                  {/* <Box bgcolor='red'>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Nisi saepe aliquam vero non impedit libero dignissimos, quae
                    explicabo aut quas similique deserunt hic maxime esse?
                    Voluptatibus saepe illum itaque voluptate! Lorem, ipsum
                    dolor sit amet consectetur adipisicing elit. Nisi saepe
                    aliquam vero non impedit libero dignissimos, quae explicabo
                    aut quas similique deserunt hic maxime esse? Voluptatibus
                    saepe illum itaque voluptate! Lorem, ipsum dolor sit amet
                    consectetur adipisicing elit. Nisi saepe aliquam vero non
                    impedit libero dignissimos, quae explicabo aut quas
                    similique deserunt hic maxime esse? Voluptatibus saepe illum
                    itaque voluptate! Lorem, ipsum dolor sit amet consectetur
                    adipisicing elit. Nisi saepe aliquam vero non impedit libero
                    dignissimos, quae explicabo aut quas similique deserunt hic
                    maxime esse? Voluptatibus saepe illum itaque voluptate!
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Nisi saepe aliquam vero non impedit libero dignissimos, quae
                    explicabo aut quas similique deserunt hic maxime esse?
                    Voluptatibus saepe illum itaque voluptate! Lorem, ipsum
                    dolor sit amet consectetur adipisicing elit. Nisi saepe
                    aliquam vero non impedit libero dignissimos, quae explicabo
                    aut quas similique deserunt hic maxime esse? Voluptatibus
                    saepe illum itaque voluptate! Lorem, ipsum dolor sit amet
                    consectetur adipisicing elit. Nisi saepe aliquam vero non
                    impedit libero dignissimos, quae explicabo aut quas
                    similique deserunt hic maxime esse? Voluptatibus saepe illum
                    itaque voluptate! Lorem, ipsum dolor sit amet consectetur
                    adipisicing elit. Nisi saepe aliquam vero non impedit libero
                    dignissimos, quae explicabo aut quas similique deserunt hic
                    maxime esse? Voluptatibus saepe illum itaque voluptate!
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Nisi saepe aliquam vero non impedit libero dignissimos, quae
                    explicabo aut quas similique deserunt hic maxime esse?
                    Voluptatibus saepe illum itaque voluptate! Lorem, ipsum
                    dolor sit amet consectetur adipisicing elit. Nisi saepe
                    aliquam vero non impedit libero dignissimos, quae explicabo
                    aut quas similique deserunt hic maxime esse? Voluptatibus
                    saepe illum itaque voluptate! Lorem, ipsum dolor sit amet
                    consectetur adipisicing elit. Nisi saepe aliquam vero non
                    impedit libero dignissimos, quae explicabo aut quas
                    similique deserunt hic maxime esse? Voluptatibus saepe illum
                    itaque voluptate! Lorem, ipsum dolor sit amet consectetur
                    adipisicing elit. Nisi saepe aliquam vero non impedit libero
                    dignissimos, quae explicabo aut quas similique deserunt hic
                    maxime esse? Voluptatibus saepe illum itaque voluptate!
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Nisi saepe aliquam vero non impedit libero dignissimos, quae
                    explicabo aut quas similique deserunt hic maxime esse?
                    Voluptatibus saepe illum itaque voluptate! Lorem, ipsum
                    dolor sit amet consectetur adipisicing elit. Nisi saepe
                    aliquam vero non impedit libero dignissimos, quae explicabo
                    aut quas similique deserunt hic maxime esse? Voluptatibus
                    saepe illum itaque voluptate! Lorem, ipsum dolor sit amet
                    consectetur adipisicing elit. Nisi saepe aliquam vero non
                    impedit libero dignissimos, quae explicabo aut quas
                    similique deserunt hic maxime esse? Voluptatibus saepe illum
                    itaque voluptate! Lorem, ipsum dolor sit amet consectetur
                    adipisicing elit. Nisi saepe aliquam vero non impedit libero
                    dignissimos, quae explicabo aut quas similique deserunt hic
                    maxime esse? Voluptatibus saepe illum itaque voluptate!
                  </Box> */}
                  <BottomNav customItems={route.navBoxItems} />
                </>
              )}
            />
          ))}
        </Switch>
      </Container>
    </>
  );
};

export default PanelLayoutNoPadding;
